const hasRole = (roles, userRole) => {

  let rolesPermission = []
  
  if(userRole.includes('Admin')) return true;

  roles?.forEach(element => {
    rolesPermission.push(userRole.includes(element))
  });

  return rolesPermission.includes(true)
};

const getRoles = () => {
  const role = JSON.parse(localStorage.getItem('currentUser'));
  return role?.role_name || 'Estudante';
};

const canDirective = {
  inserted(el, binding) {
    let allowed = false;
    if (binding.arg === 'roles') {
      allowed = hasRole(binding.value, getRoles());
    }

    if (!allowed) {
      el.parentNode.removeChild(el);
    }
  }
};

export default {
  install(Vue) {
    Vue.directive('can', canDirective);
  }
};